export default __webpack_public_path__ + "static/media/suitemaster_2.3303e892.jpg";